import React, { useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import DashboardPM from './Dashboardpm';
import ComparadorModelos from './Comparadormodelos';
import SimuladorPricing from './SimuladorPricing';
import GestionLeads from './GestionLeads';

function InteligenciaPM() {
    const { tab } = useParams();
    const activeTab = tab || 'dashboard';

    const [mounted, setMounted] = useState(() => ({ [activeTab]: true }));

    const validTabs = ['dashboard', 'comparador', 'simulador', 'leads'];
    if (!validTabs.includes(activeTab)) {
        return <Navigate to="/inteligencia/dashboard" replace />;
    }

    if (!mounted[activeTab]) {
        setMounted(prev => ({ ...prev, [activeTab]: true }));
    }

    const show = (t) => ({
        flex: 1,
        display: activeTab === t ? 'flex' : 'none',
        flexDirection: 'column',
        minWidth: 0,
        overflow: 'hidden',
    });

    return (
        <>
            {mounted.dashboard && <div style={show('dashboard')} ><DashboardPM embedded /></div>}
            {mounted.comparador && <div style={show('comparador')}><ComparadorModelos embedded /></div>}
            {mounted.simulador && <div style={show('simulador')} ><SimuladorPricing embedded /></div>}
            {mounted.leads && <div style={show('leads')}     ><GestionLeads embedded /></div>}
        </>
    );
}

export default InteligenciaPM;